/**
 * 应用入口 —— 挂载 React 应用。
 * 以 App 组件为根，由 App 内 HashRouter 管理路由。
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('找不到 #root 元素');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
